export const CANCEL_INVOICING = 'providers/invoicing/InvoicesGeneratedProvider/CANCEL_INVOICING';
export const DOWNLOAD_INVOICES = 'providers/invoicing/InvoicesGeneratedProvider/DOWNLOAD_INVOICES';
export const GET_REPORTS_GENERATED = 'providers/invoicing/InvoicesGeneratedProvider/GET_REPORTS_GENERATED';
export const GET_REPORTS_GENERATED_PAGINATION =
  'providers/invoicing/InvoicesGeneratedProvider/GET_REPORTS_GENERATED_PAGINATION';
